import LoadingScreen from "components/base/LoadingScreen/LoadingScreen";

export default LoadingScreen;
